import { getMediaVariantCandidates } from "@/utils/mediaUrlVariants";

import type { DesignFile } from "./types";

import { DesignImage } from "../../media/DesignImage";
import { VideoFrame } from "../../media/VideoFrame";
import { FileIcon } from "./FileIcon";
import { isImageDesign } from "./isImageDesign";
import { isVideoDesign } from "./isVideoDesign";

export function DesignThumbnail({
  className,
  design,
  iconClassName,
}: {
  className: string;
  design: DesignFile;
  iconClassName?: string;
}) {
  const icon = <FileIcon className={iconClassName} fileItem={design} />;

  if (design.url && isImageDesign(design)) {
    return (
      <DesignImage
        alt=""
        className={className}
        fallback={icon}
        sources={getMediaVariantCandidates(design.url, "thumbnail")}
      />
    );
  }

  if (design.url && isVideoDesign(design)) {
    return (
      <VideoFrame
        className={className}
        fallback={icon}
        title={design.name}
        url={design.url}
      />
    );
  }

  return icon;
}
